import { FastTruckIcon } from '@reveni-io/reveni-ui'

const FastTruckReverseIcon = props => <FastTruckIcon {...props} reverse />

export default FastTruckReverseIcon
